import React from "react";

export interface Column {
    title: string;
    dataIndex: string;
    key: string;
    left?: boolean;
    width?: number;
    tooltip?: string;
}

interface DataItem {
    key: string;
    value: string | React.ReactNode;
}

interface FCRodinaTableProps {
    columns: Column[];
    data: DataItem[][];
    highlightRows?: Set<number>;
    rowClass?: string;
    cellClass?: string;
}

export const FCRodinaTable: React.FC<FCRodinaTableProps> = ({ columns, data, highlightRows, rowClass, cellClass }) => {
    return (
        <table className="w-full border-collapse max-w-full sm:rounded-xl sm:overflow-hidden">
            <thead className="bg-sky-100 border-0 text-slate-500 text-center uppercase">
                <tr>
                    {columns.map(c => {
                        let thClass = "border-0 py-1 font-semibold [&:not(:last-child)]:border-r [&:not(:last-child)]:border-r-sky-200";
                        if (c.left) {
                            thClass += " text-left pl-4";
                        } else {
                            thClass += "";
                        }
                        return (
                            <th className={thClass} key={c.key} title={c.tooltip}>{c.title}</th>
                        )
                    })}
                </tr>
            </thead>
            <tbody className="bg-white">
                {data.map((item, index) => {
                    let trClass = "relative border-0 bg-sky-50/50 [&:nth-child(even)]:bg-slate-100 text-center h-12 sm:h-20";
                    if (highlightRows?.has(index)) {
                        trClass += " font-bold";
                    } else {
                        trClass += " font-medium";
                    }

                    if (rowClass) {
                        trClass += " " + rowClass;
                    }

                    return (
                        <tr key={index} className={trClass}>
                            {columns.map(c => {
                                const dataItem = item.find(v => v.key === c.key)
                                let tdClass = "relative border-0 min-w-7 sm:px-2 align-middle [&:not(:last-child)]:border-r [&:not(:last-child)]:border-r-slate-200";

                                if (cellClass) {
                                    tdClass += " " + cellClass;
                                }
                                return (
                                    <td key={index + '_' + c.key} className={tdClass}>{dataItem?.value || '0'}</td>
                                )
                            })}
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}

